module.exports = __webpack_public_path__ + "img/stock1.53497e00.png";